// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2vCMW","left":"styles_left__3SRr4"};